import { useEffect, useState } from "react"
import { ApiEndpoints, reqGetNew } from "../../../config/apiClient"
import PainelDocumentosPendentes from "./PainelDocumentosPendentes"
import LoadingModal from "../../../components/loadingModal"
import css from './styles.module.css'

export default function DocumentosPendentesPage() {

    const [loading, setLoading] = useState<boolean>(true)
    const [documentos, setDocumentos] = useState<iDocsResumo>({
        documentos_pendentes: [],
        documentos_recentes: []
    })

    useEffect(() => {
        document.title = "Documentos | OB PORTUS APP"
        getDocumentos()
        // eslint-disable-next-line
    }, [])

    async function getDocumentos() {
        setLoading(true)
        const api = await reqGetNew(ApiEndpoints.documentosPendentes)
        if (api.status === 200) {
            setDocumentos(api.data)
        }
        setLoading(false)
    }

    return (
        <div id="main">

            <LoadingModal show={loading} handleClose={() => {}} />

            <a href="/documentos/todos?pasta=0" className={css.link_none}>
                <h1 className={css.link_all}>VER TODOS <span className="material-symbols-outlined">chevron_right</span></h1>
            </a>
            <br></br>
            <PainelDocumentosPendentes title="DOCUMENTOS PENDENTES" documentos={documentos.documentos_pendentes} loading={loading} />
            <br></br>
            <PainelDocumentosPendentes title="DOCUMENTOS RECENTES - ÚLTIMOS 30 DIAS" documentos={documentos.documentos_recentes} loading={loading} />

        </div>
    )
}

interface iDocsResumo {
    documentos_pendentes: any[]
    documentos_recentes: any[]
}